import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserIcon, BriefcaseIcon, FileTextIcon, SettingsIcon, LogOutIcon, ChevronRightIcon, BellIcon } from 'lucide-react';
import Card from '../components/ui/Card';
import ThemeToggle from '../components/ui/ThemeToggle';
const Profile: React.FC = () => {
  const navigate = useNavigate();
  return <div className="p-4 pb-20" data-id="element-398">
      <div className="flex items-center justify-between mb-6" data-id="element-399">
        <h1 className="text-2xl font-bold" data-id="element-400">Profile</h1>
        <ThemeToggle data-id="element-401" />
      </div>
      <Card className="mb-6" data-id="element-402">
        <div className="flex items-center" data-id="element-403">
          <div className="h-16 w-16 rounded-full bg-teal-100 dark:bg-teal-900 flex items-center justify-center mr-4" data-id="element-404">
            <UserIcon size={32} className="text-teal-500 dark:text-teal-400" data-id="element-405" />
          </div>
          <div data-id="element-406">
            <h2 className="text-xl font-semibold" data-id="element-407">John Doe</h2>
            <p className="text-gray-600 dark:text-gray-400" data-id="element-408">john@example.com</p>
          </div>
        </div>
        <div className="mt-4 flex justify-end" data-id="element-409">
          <button className="text-sm text-teal-500 dark:text-teal-400 hover:underline" data-id="element-410">
            Edit Profile
          </button>
        </div>
      </Card>
      <div className="mb-6" data-id="element-411">
        <h3 className="text-lg font-semibold mb-3" data-id="element-412">My Dashboard</h3>
        <Card className="mb-3" data-id="element-413">
          <div className="flex items-center justify-between" data-id="element-414">
            <div className="flex items-center" data-id="element-415">
              <div className="p-2 rounded-lg bg-blue-100 dark:bg-blue-900 mr-3" data-id="element-416">
                <BriefcaseIcon size={20} className="text-blue-600 dark:text-blue-400" data-id="element-417" />
              </div>
              <div data-id="element-418">
                <h4 className="font-medium" data-id="element-419">Applications</h4>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-420">
                  3 active applications
                </p>
              </div>
            </div>
            <ChevronRightIcon size={20} className="text-gray-400" data-id="element-421" />
          </div>
        </Card>
        <Card className="mb-3" data-id="element-422">
          <div className="flex items-center justify-between" data-id="element-423">
            <div className="flex items-center" data-id="element-424">
              <div className="p-2 rounded-lg bg-purple-100 dark:bg-purple-900 mr-3" data-id="element-425">
                <FileTextIcon size={20} className="text-purple-600 dark:text-purple-400" data-id="element-426" />
              </div>
              <div data-id="element-427">
                <h4 className="font-medium" data-id="element-428">Resumes</h4>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-429">
                  2 uploaded resumes
                </p>
              </div>
            </div>
            <ChevronRightIcon size={20} className="text-gray-400" data-id="element-430" />
          </div>
        </Card>
        <Card data-id="element-431">
          <div className="flex items-center justify-between" data-id="element-432">
            <div className="flex items-center" data-id="element-433">
              <div className="p-2 rounded-lg bg-amber-100 dark:bg-amber-900 mr-3" data-id="element-434">
                <BellIcon size={20} className="text-amber-600 dark:text-amber-400" data-id="element-435" />
              </div>
              <div data-id="element-436">
                <h4 className="font-medium" data-id="element-437">Job Alerts</h4>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-438">
                  5 active alerts
                </p>
              </div>
            </div>
            <ChevronRightIcon size={20} className="text-gray-400" data-id="element-439" />
          </div>
        </Card>
      </div>
      <div className="mb-6" data-id="element-440">
        <h3 className="text-lg font-semibold mb-3" data-id="element-441">Recent Applications</h3>
        <Card data-id="element-442">
          <div className="space-y-4" data-id="element-443">
            <div className="pb-4 border-b border-gray-200 dark:border-gray-700" data-id="element-444">
              <div className="flex items-start justify-between" data-id="element-445">
                <div data-id="element-446">
                  <h4 className="font-medium" data-id="element-447">Senior React Developer</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-448">
                    SpaceX • Remote
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-449">
                    Applied 2 days ago
                  </p>
                </div>
                <span className="px-2 py-1 rounded-full text-xs bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200" data-id="element-450">
                  In Review
                </span>
              </div>
            </div>
            <div className="pb-4 border-b border-gray-200 dark:border-gray-700" data-id="element-451">
              <div className="flex items-start justify-between" data-id="element-452">
                <div data-id="element-453">
                  <h4 className="font-medium" data-id="element-454">Frontend Engineer</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-455">
                    Google • Mountain View, CA
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-456">
                    Applied 1 week ago
                  </p>
                </div>
                <span className="px-2 py-1 rounded-full text-xs bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200" data-id="element-457">
                  Interview
                </span>
              </div>
            </div>
            <div data-id="element-458">
              <div className="flex items-start justify-between" data-id="element-459">
                <div data-id="element-460">
                  <h4 className="font-medium" data-id="element-461">UX Designer</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-462">
                    Apple • Cupertino, CA
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-463">
                    Applied 2 weeks ago
                  </p>
                </div>
                <span className="px-2 py-1 rounded-full text-xs bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200" data-id="element-464">
                  Rejected
                </span>
              </div>
            </div>
          </div>
          <button className="mt-4 w-full text-center text-teal-500 dark:text-teal-400 text-sm py-2 hover:underline" data-id="element-465">
            View All Applications
          </button>
        </Card>
      </div>
      <div className="mb-6" data-id="element-466">
        <h3 className="text-lg font-semibold mb-3" data-id="element-467">Account Settings</h3>
        <Card data-id="element-468">
          <div className="space-y-3" data-id="element-469">
            <button className="w-full flex items-center justify-between py-2" data-id="element-470">
              <div className="flex items-center" data-id="element-471">
                <SettingsIcon size={18} className="mr-3 text-gray-500 dark:text-gray-400" data-id="element-472" />
                <span data-id="element-473">Settings</span>
              </div>
              <ChevronRightIcon size={18} className="text-gray-400" data-id="element-474" />
            </button>
            <div className="border-t border-gray-200 dark:border-gray-700" data-id="element-475"></div>
            <button className="w-full flex items-center justify-between py-2" data-id="element-476">
              <div className="flex items-center" data-id="element-477">
                <BellIcon size={18} className="mr-3 text-gray-500 dark:text-gray-400" data-id="element-478" />
                <span data-id="element-479">Notifications</span>
              </div>
              <ChevronRightIcon size={18} className="text-gray-400" data-id="element-480" />
            </button>
            <div className="border-t border-gray-200 dark:border-gray-700" data-id="element-481"></div>
            <button className="w-full flex items-center justify-between py-2 text-red-500" data-id="element-482">
              <div className="flex items-center" data-id="element-483">
                <LogOutIcon size={18} className="mr-3" data-id="element-484" />
                <span data-id="element-485">Logout</span>
              </div>
            </button>
          </div>
        </Card>
      </div>
    </div>;
};
export default Profile;